export default __webpack_public_path__ + "static/media/ic_d2c.141ea149b1e5b6a80542316f49fb8299.svg";